import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, apiErrorMessage } from "../api";

export default function XeroCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const [state, setState] = useState({ phase: "working", message: "Connecting to Xero…" });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const stateParam = params.get("state");
    const err = params.get("error");
    if (err) {
      setState({ phase: "error", message: params.get("error_description") || err });
      return;
    }
    if (!code || !stateParam) {
      setState({ phase: "error", message: "Missing code or state in redirect." });
      return;
    }
    (async () => {
      try {
        const res = await api.xeroCallback({ code, state: stateParam });
        setState({ phase: "ok", message: `Connected to ${res.tenant_name || "Xero"}.` });
        setTimeout(() => nav("/app/settings"), 1500);
      } catch (ex) {
        setState({ phase: "error", message: apiErrorMessage(ex, "Xero connection failed.") });
      }
    })();
  }, [location.search, nav]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6">
      <div className="bg-white rounded-xl border border-cream p-8 max-w-md w-full text-center">
        {state.phase === "working" && (
          <>
            <Loader2 size={40} className="mx-auto animate-spin text-coral" />
            <div className="mt-4 font-display text-2xl">Connecting to Xero</div>
            <p className="text-sm text-[#3f4a44] mt-2">Just a second…</p>
          </>
        )}
        {state.phase === "ok" && (
          <>
            <CheckCircle2 size={40} className="mx-auto text-coral" />
            <div className="mt-4 font-display text-2xl">Connected!</div>
            <p className="text-sm text-[#3f4a44] mt-2">{state.message}</p>
            <p className="text-xs text-[#6a736f] mt-3">Redirecting to Settings…</p>
          </>
        )}
        {state.phase === "error" && (
          <>
            <XCircle size={40} className="mx-auto text-red-600" />
            <div className="mt-4 font-display text-2xl">Something went wrong</div>
            <p className="text-sm text-[#3f4a44] mt-2 break-words">{state.message}</p>
            <button onClick={() => nav("/app/settings")} className="btn-outline-forest mt-4 px-4 py-2 rounded-md text-sm">Back to Settings</button>
          </>
        )}
      </div>
    </div>
  );
}
